import Gateway from '@/utils/Gateway';

let cacheData;

function handleRes(res, resolve) {
    const { data } = res || {};
    // status 0为已绑定 1为未绑定
    const { status, corp_secret: corpSecret, corp_id: corpId } = data || {};
    let isBindContact = false;

    if (status === 0) {
        isBindContact = true;
    }

    resolve({
        isBindContact,
        corpSecret,
        corpId,
        data
    });
}

// 获取通信录参数接口
export default function getWeworkCorpInfo(config) {
    const { useCache } = config || {};
    return new Promise((resolve, reject) => {
        if (useCache && cacheData) {
            handleRes(cacheData, resolve);
        } else {
            Gateway.get('/v1/account/wework/GetWeworkCorpInfo', {}, { originRes: true })
                .then(res => {
                    handleRes(res, resolve);
                    cacheData = res;
                })
                .catch(e => {
                    const { message } = e || {};
                    reject(message || '获取通讯录参数信息失败');
                });
        }
    });
}
